import { Timestamp } from 'firebase/firestore';

// Parse a 'yyyy-mm-dd' string (the native <input type="date"> value) into a
// Date pinned to local noon. Pinning to noon avoids timezone-edge bugs where
// saving UTC midnight would render as the previous day in negative-offset
// timezones (e.g. PDT). The trailing `T12:00:00` (no Z, no offset) makes the
// Date constructor parse as local time.
export const parseLocalNoon = (value: string): Date | null => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const d = new Date(`${value}T12:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Returns the local 'yyyy-mm-dd' for a Firestore Timestamp. Used to detect
// duplicates against what the user picked in the date input (which is also
// expressed in local time). The `en-CA` locale formats as ISO yyyy-mm-dd.
export const localDateKey = (ts: Timestamp): string =>
  ts.toDate().toLocaleDateString('en-CA');
